import Wrapper from "../../../layout/Wrapper";
import AgentServiceComponent from "../../../screens/callcenters/agents";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Agent Service",
	description: "",
};

export default function AgentService() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<AgentServiceComponent />
		</Wrapper>
	);
}